var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "o-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "o-grid",
        class: _vm.cards.length === 0 ? "o-grid--center" : "",
      },
      [
        _vm.cards.length !== 0 || _vm.showPlaceholders
          ? _c("div", { staticClass: "o-grid__item u-width-full" }, [
              _c(
                "div",
                {
                  staticClass: "cards__wrapper",
                  attrs: { id: "cardsWrapper" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "cards", attrs: { id: "cards" } },
                    [
                      _vm.showPlaceholders
                        ? _c("content-placeholders")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.cards, function (card) {
                        return _c("post-card-api", {
                          key: card.id,
                          attrs: { card: card },
                        })
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showEmptyMessage
          ? _c(
              "div",
              {
                directives: [{ name: "else", rawName: "v-else" }],
                staticClass: "o-grid__item u-width-8/12 u-width-full@l",
              },
              [
                _vm.$root.user.username === _vm.$root.profile.username
                  ? _c("div", { staticClass: "c-empty-state" }, [
                      _c("h4", [
                        _vm._v(
                          "Ready to add your first piece of " +
                            _vm._s(_vm.$root.community.title) +
                            " content?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Contributing to the communities you are a member of is one of the most valuable roles of a " +
                            _vm._s(_vm.$root.brand.name) +
                            " user, to get started simply click on the Add Content icon below."
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "c-empty-state" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.noContentMessage))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "As soon as they do it will be listed here like the example post below."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("article", { staticClass: "card dc preview empty" }, [
                        _c("div", { staticClass: "card__inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card__media",
                              attrs: { "data-card-type": "message" },
                            },
                            [
                              _c("a", { attrs: { href: "/" } }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$cdn(
                                      "/img2.0/example-article.jpg"
                                    ),
                                    alt: "example image",
                                  },
                                }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("header", [
                            _c("div", { staticClass: "card__logo" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/u/" + _vm.$root.profile.username,
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "logo",
                                    attrs: {
                                      src: _vm.$cdn(
                                        "/img/communities/1/main.jpg"
                                      ),
                                      alt: "example post",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "ugc__avatar",
                                    attrs: {
                                      src: _vm.$root.profile.avatar,
                                      width: "24",
                                      height: "24",
                                      alt:
                                        _vm.$root.profile.first_name +
                                        " " +
                                        _vm.$root.profile.surname,
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card__comm-name dc" }, [
                              _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.$root.profile.first_name) +
                                      " " +
                                      _vm._s(_vm.$root.profile.surname)
                                  ),
                                ]),
                                _vm._v(
                                  "\n                                    posted"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                    in\n                                    "
                                ),
                                _c("strong", [
                                  _c("a", { attrs: { href: "/" } }, [
                                    _vm._v(_vm._s(_vm.communityName)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("time", [_vm._v(_vm._s(_vm.postDate))]),
                            ]),
                            _vm._v(" "),
                            _vm._m(0),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "title" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$root.profile.first_name) +
                                  "'s content cards will appear once they have added and published their own unique content in a " +
                                  _vm._s(_vm.$root.brand.name) +
                                  " community."
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-ctas-wrap" }, [
                            _c("div", { staticClass: "card-ctas" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "card__likes",
                                  attrs: { "data-cy": "like-post" },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "24",
                                        height: "21",
                                        viewBox: "0 0 24 21",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z",
                                          stroke: "black",
                                          "stroke-width": "1.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("0")]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "slider-nav" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card__repost" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "22",
                                  height: "16",
                                  viewBox: "0 0 22 16",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1 4V6C1 9.31371 3.68629 12 7 12H11M21 12V10C21 6.68629 18.3137 4 15 4H11",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M14 1L11 4L14 7",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M9 15L12 12L9 9",
                                    stroke: "black",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", [_vm._v("Repost")]),
                          ]),
                        ]),
                      ]),
                    ]),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card__menu" }, [
      _c("div", { staticClass: "dots" }, [_c("div", { staticClass: "dot" })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }